import React, { useState, useEffect } from 'react';
import { subscribeToHealthStatus, getBackendHealth } from '../../services/healthCheckService';
import './HealthIndicator.css';

/**
 * Health Status Indicator Component
 * Displays a red or green icon showing backend connectivity status
 */
const HealthIndicator: React.FC = () => {
  const [isHealthy, setIsHealthy] = useState(getBackendHealth());

  useEffect(() => {
    // Subscribe to health status changes
    const unsubscribe = subscribeToHealthStatus((healthy) => {
      setIsHealthy(healthy);
    });

    return unsubscribe;
  }, []);

  return (
      <div className="health-icon">
        <div className={`health-dot ${isHealthy ? 'health-dot--healthy' : 'health-dot--unhealthy'}`} />
      </div>
    
  );
};

export default HealthIndicator;
